import CitySEOHead from "@/components/feature/CitySEOHead";
import ColoradoHeroSection from "./components/HeroSection";
import ColoradoCitiesDirectory from "./components/CitiesDirectory";
import ColoradoCommunitiesWeServe from "./components/CommunitiesWeServe";
import ColoradoStateResources from "./components/StateResources";
import ColoradoFAQSection, { faqs } from "./components/FAQSection";
import ColoradoFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function ColoradoPage() {
  return (
    <>
      <CitySEOHead
        city="Colorado"
        state="Colorado"
        stateAbbr="CO"
        route="/states/colorado"
        title="Colorado Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Colorado — Denver, Colorado Springs, Boulder, Fort Collins. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Colorado, United States"
        geoPosition="39.5501;-105.7821"
        faqs={faqs.map((f) => ({ q: f.question, a: f.answer }))}
        servicesSchema={servicesList}
        serviceAreaDesc="Fast Passport Center serves Colorado travelers with expedited and emergency passport processing. Headquarters in Washington, DC with remote service across all Colorado cities."
      />
      <div className="font-sans">
        <ColoradoHeroSection />
        <ColoradoCitiesDirectory />
        <ColoradoCommunitiesWeServe />
        <ColoradoStateResources />
        <ColoradoFAQSection />
        <SEOCrossLinks state="CO" />
        <ColoradoFinalCTA />
      </div>
    </>
  );
}